export enum GalavailRestHttpMethod {
  POST = 'POST',
  // PUT = 'PUT',
  GET = 'GET',
  // DELETE = 'DELETE'
}
